export const RECEIVE_CLIENTS = 'RECEIVE_CLIENTS';
export const GET_CLIENTS = 'GET_CLIENTS';
export const SET_CLIENT = 'SET_CLIENT';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const DELETE_CLIENT = 'DELETE_CLIENT';
export const FETCH_CLIENTS = 'FETCH_CLIENTS';
